<template>
    <notification-behavioral ref="notificationBase" class="notification-pricing-noted" :item="item"
        :behaviors="behaviors"
         @behaviorCompleted:note="handleNoteSent"
    >
        <template slot="title" :item="item">
            <div class="" style="flex:1">({{item.customerId}}) {{item.customerName}} - {{item.title}} <a :href="'/partner/customer/index/id/' + item.customerId"><span class="glyphicon glyphicon-globe"></span></a></div>
        </template>

        <div slot="body">
            <div v-for="n in item.notes" class="" style="">
                <div>{{n.createdBy}} @ {{n.createdAt}}</div>
                <div>
                    <pre>{{n.note}}</pre>
                </div>
            </div>
        </div>

        <div slot="behaviors"></div>
    </notification-behavioral>
</template>

<script>
    import NotificationBehavioral from '@/components/notifications/behaviors/Behavioral'

    export default {
        props: {
            item: {
                type: Object,
                required: true
            }
        },
        name: 'NotificationPricingRejected',
        data () {
            return {
                behaviors: [
                    {
                        name: 'note',
                        label: '',
                        description: 'Reply',
                        icon: 'glyphicon-comment',
                        requestAction: () => {
                            return '/partner/customer-opportunity/load-note/opportunityid/' + this.item.objectId
                        },
                        requestMethod: 'post'
                    }
                ]
            }
        },
        computed: {
        },
        methods: {
            handleNoteSent: function (data) {
                this.$refs.notificationBase.showBehaviorMessage(data.message, 'success')
            }
        },
        components: {
            NotificationBehavioral
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.notification-body {
    margin: 0.5em 0;
}

 .notification-body > div:first-child {
     border: 1px solid #000;
     border-width: 0;
 }

 .notification-body > div > div {
     border: 1px solid #000;
     border-width: 0px 1px 1px 0px;
     padding: 1%;
 }

 .notification-body > div > div:first-child {
     border-width: 0px 1px 1px 0px;
 }

.notification-body > div > div:last-child {
    border-right: 0;
}

.notification-body > div:last-child > div {
    border-bottom: 0;
}

.notification-pricing-completed {
    min-width:400px;
}

</style>



// WEBPACK FOOTER //
// PricingRejected.vue?0757d435